import classNames from 'classnames';
import React, { FC, useMemo } from 'react';

import Icon, { IconProps } from '../../Icon';

import styles from './InputMessage.module.scss';

export interface InputMessageProps {
  message: {
    type: 'Error' | 'Warning' | 'Processing' | 'Success' | 'Hint';
    text: string;
  };
}

const InputMessage: FC<InputMessageProps> = ({ message }) => {
  const messageIcon = useMemo(() => {
    if (message.type === 'Hint') return;

    let name: IconProps['name'];

    if (message.type === 'Error' || message.type === 'Warning') {
      name = 'warning--white';
    } else if (message.type === 'Processing') {
      name = 'loading-dots--white';
    } else {
      name = 'checkmark--white';
    }

    return (
      <Icon
        name={name}
        alt={`${message.type} icon`}
        size={20}
        className={styles.messageIcon}
      />
    );
  }, [message]);

  return (
    <div
      className={classNames(
        styles.messageWrapper,
        styles[`messageWrapper${message.type}`]
      )}
    >
      {messageIcon}
      <span className={styles.messageText}>{message.text}</span>
    </div>
  );
};

export default InputMessage;
